import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useParams} from "react-router-dom";
import IconFacebook from "../img/icons/icon-round-facebook.svg";
import IconTwitter from "../img/icons/icon-round-twitter.svg";
import IconLine from "../img/icons/icon-round-line.svg";
import defaultImage from "../img/default.jpg";

export default function News(prop) {
    let {slug} = useParams();

    let [data, setData] = React.useState(null);
    let [detail, setDetail] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getView();
                setData(resView);

                const resDetail = await getDetail();
                if(resDetail) {
                    if(prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                        resDetail.detail = resDetail.detail_en;
                    }
                    setDetail(resDetail);

                    document.title = 'ข่าว | NCSA - ' + resDetail.title;
                    const elDesc = document.querySelector("meta[name='description']");
                    elDesc.setAttribute('content', resDetail.title);
                    const elOgTitle = document.querySelector("meta[property='og:title']");
                    elOgTitle.setAttribute('content', resDetail.title);
                    const elOgDesc = document.querySelector("meta[property='og:description']");
                    elOgDesc.setAttribute('content', resDetail.title);
                    const elOgImage = document.querySelector("meta[property='og:image']");
                    elOgImage.setAttribute('content', resDetail.image ? Config.fileUpload + 'news_banner/' + resDetail.image : Config.baseUrl + 'images/default.jpg');
                    const elOgUrl = document.querySelector("meta[property='og:url']");
                    elOgUrl.setAttribute('content', window.location.href);
                }

            } catch (e) {
                //
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/newsBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/news/viewSlug', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                slug: slug
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'news_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'News':'ข่าวสาร'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / <NavLink to={ (prop.lang === 'en' ? '/en':'') + "/news"}>{prop.lang === 'en' ? 'News':'ข่าวสาร'}</NavLink> </p>
                </div>
            </div>

            <div className="section">
                <div className="container">
                    <div className="news-details" data-aos="fade-in">
                        <div className="hgroup">
                            <h2>{detail?.title}</h2>
                            <p className="date">{prop.lang === 'en' ? 'Published on':'วันที่เผยแพร่'} {Utils.dateDMY(detail?.createdAt, prop.lang)} | {prop.lang === 'en' ? 'View : ': 'ยอดเข้าชม : '} {Utils.numberWithCommas(detail?.view ?? 0)}</p>

                            <div className="share-icons mb-4" data-aos="fade-in">
                                <NavLink to={"https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(window.location.href)} target="_blank">
                                    <img className="icons" src={IconFacebook} alt="" />
                                </NavLink>
                                <NavLink to={"https://twitter.com/intent/tweet?text=" + encodeURIComponent(document.title) + ' ' + encodeURIComponent(window.location.href)} target="_blank">
                                    <img className="icons" src={IconTwitter} alt="" />
                                </NavLink>
                                <NavLink to={"https://social-plugins.line.me/lineit/share?url=" + encodeURIComponent(window.location.href)} target="_blank">
                                    <img className="icons" src={IconLine} alt="" />
                                </NavLink>
                            </div>
                        </div>

                        <div className="article">
                            {
                                detail?.image ? <p className="text-center"><img src={Config.fileUpload + 'news/' + detail?.image} alt={detail?.title} /></p> : ''
                            }
                            <div dangerouslySetInnerHTML={{__html: detail?.detail}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 